var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wout-login"},[_c('div',{staticClass:"wout-center"},[_vm._m(0),_c('span',{staticClass:"wout-desconto"},[_vm._v("Hóspede "+_vm._s(_vm.dados.nomehotel)+" tem desconto para próxima hospedagem!")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/img/desconto.svg"),"width":"auto","height":"130","alt":"Desconto!","crossorigin":""}})])
}]

export { render, staticRenderFns }